
  $('.marquee-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
        fade:true,
            infinite: true,
            arrows: false,
    autoplay:true
   
  });

   $('.press-slider-sm').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
        fade:true,
            infinite: true,
            arrows: false,
    autoplay:true
   
     }); 
    
    
  
